<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { inquiryReport, deleteBackgroundTask, downloadNormReportFile } from '../../../../api/home.js';
import config from '../../../../../configHttp';
export default {
	name: 'ReportTask',
	components: {},
	data() {
		return {
			pdfurl:"",
			pdfDiag:false,
			flag: 0,
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('ReportTaskheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('ReportTaskoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			tableHeight: 'calc(100vh - 325px )',
			Count: 0,
			sort: '',
			order: ''
			/* 表格 */
		};
	},
	mounted() {},
	activated() {
		//初始化时，会同时调用activated，连续searrchForData两次会报错
		this.flag++;
		if(this.flag > 1){
			this.searrchForData();
		}
	},
	created() {
		this.searrchForData();
	},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('ReportTaskoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('ReportTaskheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		batchdownload(id, data) {
			if (id == '-1') {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择要下载的数据');
					return;
				}
				for (var i = 0; i < this.$refs.tablebox.getSelectionval().length; i++) {
					if (this.$refs.tablebox.getSelectionval()[i].downloadPath == '' || this.$refs.tablebox.getSelectionval()[i].downloadPath == null) {
						this.$message.error('请选择有文件的数据');
						return;
					}
				}
				for (var i = 0; i < this.$refs.tablebox.getSelectionval().length; i++) {
					let params = {};
					params.id = this.$refs.tablebox.getSelectionval()[i].id;
					let req = {
						downUrl: config.baseURL + '/backGroundTask/downloadNormReportFile?id=' + params.id,
						typeObj: {
							toForm: false,
							fileType: 'xls',
							fileName: this.$refs.tablebox.getSelectionval()[i].downloadPath
						}
						// params: params
					};
					this.$downloadcommon(req);
				}
			} else {
				if (data.downloadPath == '' || data.downloadPath == null) {
					this.$message.error('报表没有文件');
					return;
				}
				let params = {};
				params.id = data.id;
				let req = {
					downUrl: config.baseURL + '/backGroundTask/downloadNormReportFile?id=' + data.id,
					typeObj: {
						toForm: false,
						fileType: 'xls',
						fileName: data.downloadPath
					}
					// params: params
				};
				this.$downloadcommon(req);
			}
		},
		forToSeePdf(id){
			this.pdfDiag=true
			this.$nextTick(()=>{
				this.pdfurl = config.baseURL + '/backGroundTask/previewPdf?id='+id
				// this.pdfurl="https://electricticket.oss-cn-shanghai.aliyuncs.com/%E4%BA%91%E5%B0%8F%E5%BC%80%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf"
			})
		},
		//删除
		deleteTCode(id) {
			if (this.$refs.tablebox.getSelectionval().length == 0 && id == '-1') {
				this.$message.error('请选择要删除的数据');
				return;
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					if (id != '-1') {
						params.ids = id;
					} else {
						params.ids = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
					}

					deleteBackgroundTask(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		downloadErrorMessage(id) {
			let params = {};
			let req = {
				downUrl: config.baseURL + '/backGroundTask/downloadErrorMessage?id=' + id,
				typeObj: {
					toForm: false,
					fileType: 'txt',
					fileName: '错误日志.log'
				}
				// params: params
			};
			this.$downloadcommon(req);
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			// params.criteriaJson = '{"batchNo":"","createTime_start":"2012-12-01 00:00:00.0000000","createTime_end":"2022-12-02 23:59:59.0000000","subType":""}';
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			inquiryReport(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data.map(v => {
						var company = v.downloadPath.split('/');
						let value = company[company.length - 1];
						if (value.indexOf('\\')) {
							let valueRes = value.split('\\');
							value = valueRes[valueRes.length - 1];
						}
						v.downloadPath = value;
						return v;
					});
					this.pagination.total = res.data.count;
				}
			});
		},
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},

		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
